<template>
	<div class="daily-close-content">
		<ModalHeader
			:title="languageStore.getString('daily_close')"
			:button-text="languageStore.getString('print')"
			@click-button="printCurrentTransactedTotal" />
		<div class="dates-container">
			<AppTextInput type="date" class="mb-15" :label="languageStore.getString('date')" ref="close-date" :value="dateClose" @changed-text="(v) => dateClose = v" />
			<AppTextInput type="time" class="mb-15" :label="languageStore.getString('time_start')" ref="close-time-start" :value="startTimeClose" @changed-text="(v) => startTimeClose = v" />
			<AppTextInput type="time" class="mb-15" :label="languageStore.getString('time_end')" ref="close-time-end" :value="endTimeClose" @changed-text="(v) => endTimeClose = v" />
		</div>
	</div>
</template>

<script>
import AppTextInput from "@/shared/components/AppTextInput.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore} from "@/shared/stores";
import {useAdministrationStore} from "@/console-new/stores";
import {PosPrinter} from "@/console-pos/helpers/PosPrinter.js";
import {useUserStore} from "@/user/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const administrationStore = useAdministrationStore();
		const posPrinter = PosPrinter;
		const userStore = useUserStore();
		return {languageStore, administrationStore, posPrinter, userStore};
	},
	data() {
		return {
			totalShiftTransacted: 0,
			totalShiftTransactions: 0,
			totalShiftRefunds: 0,
			totalShiftCancels: 0,
		}
	},
	name: "PhysicalPosDailyClose",
	emits: ["show-error"],
	components: {ModalHeader, AppTextInput},
	computed: {
	},
	methods: {
		printCurrentTransactedTotal() {
			let date = this.$refs["close-date"].value;
			if(date.length > 0) {
				date = new Date(date);
			} else {
				date = new Date();
			}
			let dateStart = new Date(date);
			let timeStart = this.$refs["close-time-start"].value;
			if(timeStart.length > 0) {
				let timeStartSplit = timeStart.split(":");
				dateStart.setHours(timeStartSplit[0] || 0);
				dateStart.setMinutes(timeStartSplit[1] || 0);
			} else {
				dateStart.setHours(0);
				dateStart.setMinutes(0);
			}
			let timeEnd = this.$refs["close-time-end"].value;
			let dateEnd = new Date(date);
			if(timeEnd.length > 0) {
				let timeEndSplit = timeEnd.split(":");
				dateEnd.setHours(timeEndSplit[0] || 23);
				let minuteEnd = Number(timeEndSplit[1]) || 58
				dateEnd.setMinutes(minuteEnd+1);
			} else {
				dateEnd.setHours(23);
				dateEnd.setMinutes(59);
			}
			if(dateStart.getTime() > dateEnd.getTime()) {
				dateEnd.setDate(dateEnd.getDate() + 1);
			}
			this.fetchShiftData(dateStart, dateEnd, () => {
				this.posPrinter.printPOSCloseOut(this.userStore.currBusiness.name, dateStart, dateEnd, this.totalShiftTransacted, this.totalShiftTransactions, this.totalShiftRefunds, this.totalShiftCancels, this.totalFees);
			});
		},
		fetchShiftData(startDate, endDate, callback = null) {
			this.administrationStore.getCurrentShiftTransactions(startDate, endDate, (shiftObj, errorDetails)=>{
				if(shiftObj) {
					this.totalShiftTransacted = shiftObj.amount;
					this.totalShiftTransactions = shiftObj.transactions;
					this.totalShiftRefunds = shiftObj.refunds;
					this.totalShiftCancels = shiftObj.cancels;
					this.totalFees = shiftObj.fees;
					callback && callback();
				} else {
					this.$emit("show-error", this.languageStore.getString('try_later_error'));
				}
			})
		},
	}
}
</script>

<style scoped lang="scss">
.dates-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	@media (max-width: 1080px) {
		flex-direction: column;
		justify-content: center;
	}
}
</style>